<template>
  <div class="viz">
    <div id="bg" class="bg-home" />
    <h1>discover the data behind Unsplash</h1>

    <Scrollama :offset="0.9" :debug="false" :progress="false">
      <div slot="graphic" class="graphic">
        <div class="showbox">
          <h2>discover images with data visualization</h2>
          <p>
            You may or may not know of
            <br>
            <a href="https://unsplash.com/" taget="_blank">
              <i>Unsplash, the internet’s source of freely useable images</i>
            </a>.
          </p>
          <p>Here, on viz.photos you can discover Unsplash’s images in a different way. Three visualizations show May 2019’s uploaded images base on color palette, exif data and keywords provided by the photographers.</p>
          <p>Enjoy.</p>
        </div>
      </div>

      <div class="step color" data-step="color">
        <div class="textbox">
          <h2>photos by color</h2>
          <p>Two different image analyzers extracted the main color of each image. Using this result, images were organized in a color space. The visualization is not only surprizing, but beautiful as well.</p>
          <a href="/color-canvas">discover images by color</a>
          <!-- {{ currentStepProgress }} -->
        </div>
      </div>
      <div class="step camera" data-step="camera">
        <div class="textbox">
          <h2>photos by camera</h2>
          <p>What cameras are used by photographers these days? What is the most used focal length or exposure time?</p>
          <p>Find out in this data visualization</p>
          <a href="/camera">discover images by camera</a>
        </div>
      </div>
      <div class="step tag" data-step="tag">
        <div class="textbox">
          <h2>photos by tags</h2>
          <p>What are the trending topics of all uploaded images?</p>
          <p>This visualization is looking at the tags each photographer can attach to the photos</p>
          <a href="/tag">discover images by tags</a>
        </div>
      </div>

      <div class="step credit" data-step="credit">
        <div class="textbox">
          <h2>background photos</h2>
          <p>images used on this site where contributed by</p>
          <ul>
            <li>
              <a href="https://unsplash.com/@davidjorre" target="_blank">David Jorre</a>
            </li>
            <li>
              <a href="https://unsplash.com/@christianperner" target="_blank">Christian Perner</a>
            </li>
            <li>
              <a href="https://unsplash.com/@joannakosinska" target="_blank">Joanna Kosinska</a>
            </li>
            <li>
              <a href="https://unsplash.com/@spandl" target="_blank">Ralph Spandl</a>
            </li>
          </ul>
        </div>
      </div>
    </Scrollama>
  </div>
</template>

<script>
import "intersection-observer"
import Scrollama from "vue-scrollama"
import { lazyLoadImages } from "../mixins/lazyLoad.js"

export default {
    name: "Homepage",
    mixins: [lazyLoadImages],
    components: {
        Scrollama
    }
}
</script>

<style src="vue-scrollama/dist/vue-scrollama.css"></style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus">
h3 {
  margin: 40px 0 0;
}

.bg-home {
  position: fixed;
  top: 0;
  height: 100vh;
  width: 100%;
  z-index: - 1;
  transition: all 1s ease-out;
  background: #FFF url('/assets/images/home/background-1.jpg') no-repeat center center fixed;
  background-size: cover;
  resize: both;

  &:before {
    content: '';
    position: fixed;
    top: 0;
    height: 100%;
    width: 100%;
    background: linear-gradient(180deg, rgba(255, 255, 255, 0.8) 0%, rgba(255, 255, 255, 0) 80%);
  }
}

.btn {
  cursor: pointer;
}

.graphic {
  width: 90vw;
  min-height: 70vh;
  margin: 0 auto;
  margin: 0px auto;
  padding: 60px 0;

  & .showbox {
    padding: 30px 0 40px;
    text-align: center;
    margin: 0 auto;
    width: 80%;
    max-width: 800px;
    height: 100%;
    border: 1px solid white;
    background-color: rgba(255, 255, 255, 0.7);

    @media (max-width: 800px) {
      width: 95%;
    }

    & h2 {
      color: slategrey;
      margin: 40px auto 40px;
      padding: 0 40px;

      @media (max-width: 800px) {
        padding: 0 10px;
      }
    }

    & p {
      font-size: 20px;
      line-height: 40px;
      padding: 0 60px;
      margin: 5px 0 28px;

      @media (max-width: 800px) {
        text-align: left;
        font-size: 16px;
        line-height: 24px;
        padding: 0 10px 0 25px;
      }
    }
  }
}

& .step {
  padding: 40px 0 100px;
  min-height: 70vw;
  border-top: 10px solid slategrey;

  &.credit {
    min-height: 40vw;
  }

  & .textbox {
    margin: 80px auto 0;
    padding: 40px 0 20px;
    max-width: 800px;
    color: white;
    background-color: rgba(0, 0, 0, 0.6);
    text-align: center;

    @media (max-width: 800px) {
      background-color: rgba(0, 0, 0, 0.8);
    }

    & h2 {
      margin: 40px auto 40px;
      padding: 0 40px;
    }

    & p {
      font-size: 20px;
      line-height: 32px;
      padding: 0 15%;
      margin: 5px 0 10px;

      @media (max-width: 800px) {
        text-align: left;
        font-size: 16px;
        line-height: 24px;
        padding: 0 10px 0 25px;
      }
    }

    & a {
      display: inline-block;
      margin: 25px 0;
      padding: 8px 12px 8px;
      background-color: white;
      box-shadow: 3px 3px 4px rgba(0, 0, 0, 0.6);
    }
  }
}

& .step {
  background-size: cover;
  resize: both;

  @media (min-width: 801px) {
    &.color {
      background: #FFF url('/assets/images/home/background-2.jpg') no-repeat center center fixed;
    }

    &.camera {
      background: #FFF url('/assets/images/home/background-camera.jpg') no-repeat center center fixed;
    }

    &.tag {
      background: #FFF url('/assets/images/home/background-tag.jpg') no-repeat center center fixed;
    }
  }

  @media (max-width: 800px) {
    &.color {
      background: linear-gradient(
        rgba(36, 198, 227, 0.5),
        rgba(36, 198, 227, 0.1)
      ), url('/assets/images/home/background-2.jpg') no-repeat center center;
    }

    &.camera {
      background: linear-gradient(
        rgba(227, 89, 25, 0.8),
        rgba(227, 89, 25, 0.1)
      ), url('/assets/images/home/background-camera.jpg') no-repeat center center;

    }

    &.tag {
      background: linear-gradient(
        rgba(222, 22, 202, 0.5),
        rgba(222, 22, 202, 0.1)
      ), url('/assets/images/home/background-tag.jpg') no-repeat center center;
    }
  }

  &.credit {
    background: #FFF url('/assets/images/home/background-credits.jpg') no-repeat center center fixed;

    p {
      font-size: 16px;
      text-align: center;
    }

    & ul {
      & li {
        font-size: 12px;
        line-height: 24px;
        list-style-type: none;

        @media (max-width: 800px) {
          padding: 0 0 12px;
        }

        & a {
          color: white;
          display: inline;
          margin: 0;
          background: none;
          box-shadow: none;
        }
      }
    }
  }
}
</style>
